import classes from './AddAttachmentsBulkCategoryEditDialog.module.scss'
import { Dialog } from 'primereact/dialog'
import { IAttachmentBulkFileObject } from '../AddAttachmentsBulkV2'
import { useEffect, useState } from 'react'
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown'
import { CertificateDocumentTypeV2 } from '../../../../../../enums/CertificateDocumentType'
import {
  ICategoryType,
  InspectionCategoryList,
  R2CCategoryList,
  TestReportCategoryList,
} from '../../../../../../enums/CetificateFileCategoryType'
import { useDispatch } from 'react-redux'
import { updateAttachmentList } from '../../../../../../features/createCertificate/createCertificateSlice'
import {
  CertificateTypeList,
  IContentType,
  TestReportTypeList,
} from '../../../../../../enums/CetificateFileContentType'

interface AddAttachmentBulkCategoryEditDialogProps {
  closeModal: () => void
  visible: boolean
  selectedRows: IAttachmentBulkFileObject[] | null
  activeDocumentType: CertificateDocumentTypeV2
}
const AddAttachmentBulkCategoryEditDialog = (props: AddAttachmentBulkCategoryEditDialogProps) => {
  const dispatch = useDispatch()
  const [selectedCategory, setSelectedCategory] = useState<any | null>(null)
  const [dropdownList, setDropdownList] = useState<ICategoryType[] | IContentType[]>([])
  const isContentType = [
    CertificateDocumentTypeV2.Certificate,
    CertificateDocumentTypeV2.TestReport,
  ].includes(props.activeDocumentType)

  const label = isContentType ? 'Content Type' : 'Category'

  useEffect(() => {
    if (props.activeDocumentType === CertificateDocumentTypeV2.Certificate)
      setDropdownList(CertificateTypeList)
    else if (props.activeDocumentType === CertificateDocumentTypeV2.TestReport)
      setDropdownList(TestReportTypeList)
    else if (props.activeDocumentType === CertificateDocumentTypeV2.R2CPackage)
      setDropdownList(R2CCategoryList)
    else setDropdownList(InspectionCategoryList)
  }, [])

  const isConfirmButtonDisabled = () => {
    return (
      !selectedCategory ||
      !props.selectedRows?.some(row => row.ecmFileNodeId == null)
    )
  }
  const save = async () => {
    const editableRows = props.selectedRows?.filter(row => row.ecmFileNodeId == null)
    const updatedRows = editableRows?.map(row => {
      return {
        tempUniqueId: row.tempUniqueId,
        newValue: selectedCategory,
        group_index: props.activeDocumentType,
      }
    })

    if (!updatedRows?.length) {
      hideModal()
      return
    }

    dispatch(updateAttachmentList(updatedRows))
    hideModal()
  }
  const hideModal = () => {
    props.closeModal()
  }
  const onValueChange = async (e: DropdownChangeParams) => {
    setSelectedCategory(e.value)
  }

  const renderHeader = (
    <div className={`${classes['dialog-header']} ${classes['center-items']}`}>Select {label}</div>
  )

  const renderFooter = (
    <>
      <hr className="modal-footer-hr" />
      <div className={`${classes['dialog-footer']} ${classes['center-items']}`}>
        <button
          className={`ul-button -medium ${classes['dialog-save-btn']} confirm-button-target`}
          disabled={isConfirmButtonDisabled()}
          onClick={save}
        >
          SAVE
        </button>

        <button
          className={`ul-button -medium ${classes['dialog-cancel-btn']}`}
          onClick={() => {
            hideModal()
          }}
        >
          CANCEL
        </button>
      </div>
    </>
  )
  const renderBody = () => {
    return (
      <>
        <div>
          {label}
          <span
            className={classes['error']}
            style={{
              marginLeft: '5px',
            }}
          >
            *
          </span>
        </div>
        <div>
          <Dropdown
            value={selectedCategory}
            options={dropdownList}
            optionLabel="name"
            onChange={onValueChange}
            className={classes['custom-dropdown']}
            style={{
              width: '100%',
              marginTop: '5px',
              marginBottom: '5px',
            }}
            placeholder="Select"
            optionDisabled="disabled"
          />
        </div>
      </>
    )
  }
  return (
    <>
      <Dialog
        className={classes['custom-dialog']}
        header={renderHeader}
        footer={renderFooter}
        draggable={false}
        visible={props.visible}
        onHide={hideModal}
        style={{ width: '30vw' }}
      >
        <hr className="modal-header-hr" />
        <div className={classes['body-container']}>
          <div>{renderBody()}</div>
        </div>
      </Dialog>
    </>
  )
}
export default AddAttachmentBulkCategoryEditDialog
